type ImageSrcSetParams = {
  mobileMaxWidth: number;
  desktopMaxWidth: number;
  aspectRatio?: number;
  assetUrl: string;
};

export const ANIMATED_GIF = /-999x-999/;

export function getImageSrcSets({
  mobileMaxWidth,
  desktopMaxWidth,
  aspectRatio,
  assetUrl,
}: ImageSrcSetParams) {
  if (/^.*\.(gif)/.test(assetUrl)) {
    console.error(
      ".gif passed into getImageSrcSets, cannot create srcsets",
      assetUrl,
    );

    return { mobile: "", desktop: "" };
  }

  return {
    mobile: [1, 2]
      .map((pixelDensity) => {
        const w = mobileMaxWidth * pixelDensity;
        const h = aspectRatio ? Math.round(w / aspectRatio) : -1;

        return getResizedImageUrl(assetUrl, w, h, true, pixelDensity);
      })
      .join(", "),
    desktop: [1, 2]
      .map((pixelDensity) => {
        const w = desktopMaxWidth * pixelDensity;
        const h = aspectRatio ? Math.round(w / aspectRatio) : -1;

        return getResizedImageUrl(assetUrl, w, h, true, pixelDensity);
      })
      .join(", "),
  };
}

export function getHeightConstrainedToAspectRatio({
  width,
  aspectRatio,
}: {
  width: number;
  aspectRatio?: number;
}) {
  return aspectRatio ? Math.round(width / aspectRatio) : -1;
}

export function getWidthConstrainedToAspectRatio({
  height,
  aspectRatio,
}: {
  height: number;
  aspectRatio?: number;
}) {
  return aspectRatio ? Math.round(height * aspectRatio) : -1;
}

export function getFallbackImageUrl(
  assetUrl: string,
  width = 25,
  height = 19,
  srcSet?: boolean,
  srcSetPixelDensity?: number,
) {
  return getResizedImageUrl(
    assetUrl,
    width,
    height,
    srcSet,
    srcSetPixelDensity,
  )?.replace(/.webp/, ".jpg");
}

export function getResizedImageUrl(
  assetUrl: string,
  width = 25,
  height = 19,
  srcSet?: boolean,
  srcSetPixelDensity?: number,
) {
  if (ANIMATED_GIF.test(assetUrl)) {
    return assetUrl
      .replace(/^http:\/\//, "//")
      .replace(/^\/\//, "https://")
      .replace(/.webp/, ".gif");
  }

  return assetUrl
    .replace(/^http:\/\//, "//")
    .replace(/^\/\//, "https://")
    .replace(
      /(\/)(-*\d+x-*\d+)(.\w+)$/,
      `$1${width}x${height}$3${
        srcSet
          ? ` ${srcSetPixelDensity ? `${srcSetPixelDensity}x` : `${width}w`}`
          : ""
      }`,
    );
}
